export const getLocation = ({ state, country }) => {
  const TWO = 2;
  const regionNamesInEnglish = new Intl.DisplayNames(["en"], {
    type: "region"
  });
  const countryName =
    country?.length === TWO ? regionNamesInEnglish.of(country) : country;

  return [state, countryName].filter(Boolean).join(", ");
};

export const getFullName = ({ first_name, last_name }) =>
  `${first_name ?? ""} ${last_name ?? ""}`;

export const getNameSlug = ({ first_name, last_name }) => {
  const firstName = first_name.replace(/\W+/g, "");
  const surname = last_name.replace(/\W+/g, "");

  return `${firstName}-${surname}`.toLowerCase();
};

export const getTwitterUser = ({ twitter }) => twitter.replace("@", "");
export const getXUser = getTwitterUser;

export const getLinkedInURL = ({ linked_in }) => {
  const linkedinUserSlug = linked_in.replace(
    /.*linkedin\.com\/in\/([^/]+)\/?.*/,
    "$1"
  );

  return linkedinUserSlug
    ? `https://www.linkedin.com/in/${linkedinUserSlug}`
    : null;
};

export const getCommunityProfileUrl = (user) =>
  `/community/members/profile/${user.id}/${encodeURIComponent(
    getNameSlug(user)
  )}`;
